import { Controller } from "@hotwired/stimulus"

const DEBOUNCE_MS = 400

export default class extends Controller {
  static targets = ["content", "body"]
  static values = { url: String, paramName: String, errorMessage: String, loadingMessage: String }

  connect() {
    this.renderMessage(this.loadingMessageValue, 'text-muted')
    this.render()
  }

  disconnect() {
    clearTimeout(this.debounceTimeout)
    this.pendingRequest?.abort()
  }

  schedule() {
    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(() => this.render(), DEBOUNCE_MS)
  }

  async render() {
    this.pendingRequest?.abort()
    this.pendingRequest = new AbortController()

    const body = new FormData()
    body.append(this.paramNameValue, this.contentTarget.value)

    try {
      // redirect: 'manual' so an expired session or a denied authorization lands in the catch
      // instead of injecting the followed login/dashboard page into the pane as a 200.
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'text/html'
        },
        body,
        redirect: 'manual',
        signal: this.pendingRequest.signal
      })

      if (!response.ok) throw new Error(response.status)

      this.bodyTarget.innerHTML = await response.text()
    } catch (error) {
      if (error.name === 'AbortError') return

      this.renderMessage(this.errorMessageValue, 'text-danger')
    }
  }

  renderMessage(message, textClass) {
    this.bodyTarget.textContent = ''

    const paragraph = document.createElement('p')
    paragraph.className = `${textClass} mb-0`
    paragraph.textContent = message

    this.bodyTarget.appendChild(paragraph)
  }
}
